import { BusinessUnitItemSchema } from "@/schemas/business-unit/business-unit-item";
import { ProductItemSchema } from "@/schemas/product/product-item";
import { z } from "zod";

export const HardwareItemSchema = z.object({
  Id: z.string().uuid(),
  Name: z.string().optional(),
  DateDelivered: z.string().optional(),
  DateInstalled: z.string().optional(),
  LicenseKey: z.string().optional(),
  DatePaid: z.string().optional(),
  DateShipped: z.string().optional(),
  DateSold: z.string().optional(),
  DateStarted: z.string().optional(),
  DeliveryStatus: z.string().optional(),
  InvoiceCreated: z.boolean().optional(),
  InvoiceSent: z.boolean().optional(),
  PackageCount: z.number().optional(),
  IsPaid: z.boolean().optional(),
  PaidStatusCode: z.number().optional(),
  ProductImage: z.string().optional(),
  ProductNumber: z.string().optional(),
  PurchasedProductId: z.string().optional(),
  ProductStatusCode: z.number().optional(),
  ProductStatusName: z.string().optional(),
  Quantity: z.number().optional(),
  SerialNumber: z.string().optional(),
  ShipmentType: z.string().optional(),
  DeliveryStatusDate: z.string().optional(),
  DeliveryStatusLocation: z.string().optional(),
  DeliveryStatusMessage: z.string().optional(),
  DeliveryStatusName: z.string().optional(),
  DeliveryCourier: z.string().optional(),
  TrackingNumber: z.string().optional(),
  Installed: z.boolean().optional(),
  StatusCode: z.number().optional(),
  ProductId: ProductItemSchema.shape.Id.optional(),
  ProductName: z.string().optional(),
  BusinessUnitId: BusinessUnitItemSchema.shape.Id.optional(),
  BusinessUnitName: z.string().optional(),
  Product: ProductItemSchema.optional(),
  IsInstalled: z.boolean().optional(),
  IsNotInstalled: z.boolean().optional(),
  IsCanceled: z.boolean().optional(),
  SwitchAssigned: z.boolean().optional(),
});

export type HardwareItemType = z.infer<typeof HardwareItemSchema>;
